/**
 * @author wuTao
 * @description NEV认证详情页面配置
 * @Date  2022/04/29
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool,utils_tool } from '@/tool';
import { nevRemoteAuthDetailExcelColumns } from './excelColumns'
import moment from "moment";
let { WizContainer, WizReduxTemplate, WizInputNumber } = framework_tool;
let { WizBrowserExport } = component_tool;
let {Session} = utils_tool;
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/remoteAuth/remoteAuthList/nevRemoteAuthDetail') {
      if (history.location && history.location.record) {
        record = {...history.location.record,jumpPageType:'nevDetail'};
        Session.set('nevRemoteAuthDetailRecord', record)
      } else {
        record = Session.get('nevRemoteAuthDetailRecord') || 0
      }
    }
  } else {
    record = Session.get('nevRemoteAuthDetailRecord') || 0
  }
  return record
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
class NevRemoteAuthDetailList extends WizContainer {
  componentName = 'nevRemoteAuthDetailList';
  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
    this.initialValue = getParamRecord(props.history);
    this.keyforms = new Date().getTime();
  }
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = nevRemoteAuthDetailExcelColumns;
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.forEach(d => {
        const {startDate, endDate,authDate} =d;
        let _d = { ...d }
        let authTimeStr = '';
        if (startDate != null && startDate!='' && endDate != null && endDate!='') {
          authTimeStr = formatterTime(startDate) + ' ~ ' + formatterTime(endDate);
        }
        let authDateStr = '';
        if (authDate != null && authDate!='') {
          authDateStr = formatterDate(authDate);
        }
        _d.authTimeStr = authTimeStr;
        _d.authDateStr = authDateStr;
        if ((!_d.score && _d.score != 0) || _d.score < 0) {
          _d.score = "";
        }
        _data.push(_d)
      });
      let dateTime = formatterDateTime(new Date());
      WizBrowserExport({
        title: 'NEV认证详情信息',
        sheetName: 'NEV认证详情信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: 'NEV认证详情信息-'+dateTime+'.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let initialValue = this.initialValue;
    const {id, name,jumpPageType} = initialValue;

    let keyforms = this.keyforms;
    let _templateConfig=templateConfig({self:this,name,jumpPageType});
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:_templateConfig,
      apiDataFormat: {
        export: this._handleFile
      },
      remoteAuthId : id,
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(NevRemoteAuthDetailList);
